<template>


  <div v-if="store.form.currentStep === 'stepOne'">


    <Steps class="mt-4 mt-md-0" @finishStepEmit="finishStepEmit"/>
    <div class="pl-3 pl-lg-1 pr-3 pr-md-4 pt-4">

      <div class="row">

        <div class="col-12 col-md-6 colBorder mb-3 mb-md-0 py-0">

          <!--          SELECT SIDLO START-->
          <div class="jakeFormCustomLabel pb-2">{{ t('personalForm.headers.addressYouLike') }}</div>

          <div class="dropdown jake-dropdown mb-0 border border-1">
            <a class="dropdown-toggle pt-2" href="#" role="button" data-toggle="dropdown"
               aria-expanded="false">
              <span v-if="selectSeat" class="ml-2">
                {{ t('sidla.' + selectSeat.code) }}
              </span>
              <span v-else class="ml-2" :class="{'text-danger is-invalid' : (!selectSeatYear && isBlurred())}">
                 {{ t('sidla.notSelected') }}
              </span>
            </a>

            <div class="dropdown-menu w-100" aria-labelledby="dropdownPhone">
              <div class="dropdown-arrow"></div>
              <span class="dropdown-item-text text-uppercase text-muted">
            <small>{{ t('personalForm.headers.selectAddress') }}</small></span>
              <span class="dropdown-item cursorLink" v-for="item in store.form.seatsProducts"
                    @click="()=>{setSeat(item); updateSeatInOrder();}" :class="{ 'text-secondary': item == selectSeat}">
                  {{ t('sidla.' + item.code) }}
                </span>
            </div>
          </div>
        </div>
        <!--        SELECT SIDLO END-->

        <!--        SELECT OBDOBI START-->
        <div class="col-12 col-md-6 colBorder mb-md-3 py-0">
          <div class="jakeFormCustomLabel pb-2">{{ t('personalForm.headers.howLong') }}</div>
          <div class="dropdown jake-dropdown mb-0 border border-1"
               :class="{ 'bg-muted' : !selectSeat}">
            <a class=" dropdown-toggle pt-2"
               :class="{ 'disabled text-disabled' : !selectSeat}"
               href="#" role="button" data-toggle="dropdown"
               aria-expanded="false">
              <span v-if="selectSeatYear" class="ml-2">
                {{ t('years.m' + selectSeatYear.months) }} – {{ selectSeatYear.totalPriceWithoutVatFilter }} {{ t('vat.withoutVat') }}
              </span>
              <span v-else-if="!selectSeat" class="ml-2" :class="{'text-danger' : (!selectSeatYear && isBlurred())}">
                 {{ t('years.seatNotSelected') }}
              </span>
              <span v-else class="ml-2" :class="{'text-danger is-invalid' : (!selectSeatYear && isBlurred())}">
                 {{ t('years.notSelected') }}
              </span>
              <!--              <div v-if="!selectSeat" class="position-absolute" style=" right: 10px; top: 12px; ">-->
              <!--                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">-->
              <!--                  <path d="M1 1L7 7L13 1" stroke="#BDBDBD" stroke-width="1.33" stroke-linecap="round"-->
              <!--                        stroke-linejoin="round"/>-->
              <!--                </svg>-->
              <!--              </div>-->
              <!--              <div v-else class="position-absolute" style=" right: 10px; top: 12px; ">-->
              <!--                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">-->
              <!--                  <path d="M1 1L7 7L13 1" stroke="#8A8A8A" stroke-width="1.33" stroke-linecap="round"-->
              <!--                        stroke-linejoin="round"/>-->
              <!--                </svg>-->
              <!--              </div>-->
            </a>

            <div class="dropdown-menu w-100" aria-labelledby="dropdownPhone">
              <div class="dropdown-arrow"></div>
              <span class="dropdown-item-text text-uppercase text-muted">
            <small>{{ t('personalForm.headers.selectPeriod') }}</small></span>
              <span class="dropdown-item cursorLink" v-if="selectSeat" v-for="year in selectSeat.formYears"
                    @click="()=>{setSeatYear(year); updateSeatInOrder();}"
                    :class="{ 'text-secondary': year == selectSeatYear}">
                {{ t('years.m' + year.months) }} – {{ year.totalPriceWithoutVatFilter }} {{ t('vat.withoutVat') }}
                <br>
                <span class="badge badge-secondary rounded" v-if="year.months === '12' && selectSeat.firstYearWebDiscountPercent">
                  <s>{{selectSeat.totalPriceWithoutVatNoSaleFilter}}</s> | {{t('sale')}} {{selectSeat.firstYearWebDiscountPercent}} % {{t('na')}} 1. {{t('year')}}
                </span>
                </span>
            </div>
          </div>
        </div>
        <!--        SELECT OBDOBI END-->

        <div v-if="lang === 'cs' && selectSeatYear && selectSeatYear.months === '12' && selectSeat && selectSeat.firstYearWebDiscountPercent&& !hideSalePromoInfo"
             class="col-12 mt-2">
          <div class="small px-2 py-1 rounded" style="background-color: #fdeced;">
            <span v-html="t('salePromoInfo', { date: salePromoEndDate })"></span>
          </div>
        </div>

      </div>
      <hr>
      <div class="row">

        <!-- Levy sloupec-->
        <div class="col-12 col-md-6 colBorder">
          <div class="row">

            <!--            OBJEDNAVAM SIDLO PRO START-->
            <div class="col-12 mt-2">
              <div class="jakeFormCustomLabel mb-2">{{ t('personalForm.headers.objednavamPro') }}:</div>
              <div v-if="isBlurred() && !choosedOsobu" class="small error-block text-danger mb-2">
                {{ t('personalForm.required.selectOne') }}
              </div>

              <div class="custom-control custom-radio">

                <input type="radio" class="custom-control-input" id="osobaPravnicka" value="pravnicka"
                       v-model="store.form.osoba"
                       :class="{'is-invalid': isBlurred() && !choosedOsobu}"
                       v-on:click="store.form.osoba = 'pravnicka'; zmenaSidlaProducts()"/>
                <label class="custom-control-label"
                       for="osobaPravnicka">{{ t('personalForm.radioButtons.pravnickaOsoba') }}</label>

              </div>

              <div class="custom-control custom-radio">
                <input type="radio" id="osobaFyzicka" class="custom-control-input" value="fyzicka"
                       v-model="store.form.osoba"
                       :class="{'is-invalid': isBlurred() && !choosedOsobu}"
                       v-on:click="store.form.osoba = 'fyzicka'; zmenaSidlaProducts()"/>
                <label class="custom-control-label" for="osobaFyzicka">{{
                    t('personalForm.radioButtons.fyzickaOsoba')
                  }}</label>

              </div>
              <hr class="d-md-none">
            </div>
            <!--            OBJEDNAVAM SIDLO PRO END-->

            <!--            FIRMA EXISTUJE START-->
            <div class="col-12 mt-4 mb-4">
              <div class="jakeFormCustomLabel mb-2">{{ t('personalForm.headers.jizFirmaExistuje') }}
                <!--                <tooltip title="firmaJizExistuje"></tooltip>-->
                <br>
                <span class="jakeFormCustomSmallLabel">
              {{ t('tooltips.firmaJizExistuje') }}
              </span>
              </div>
              <div v-if="isBlurred() && !choosedIco" class="small error-block text-danger mb-2">
                {{ t('personalForm.required.selectOne') }}
              </div>
              <div class="custom-control custom-radio">
                <input type="radio" id="cinnostMain" class="custom-control-input"
                       :class="{'is-invalid': isBlurred() && !choosedIco}"
                       value="mam"
                       v-model="store.form.mamIco"
                       v-on:click="store.form.mamIco = 'mam'; zmenaSidlaProducts()"/>
                <label class="custom-control-label" for="cinnostMain">{{
                    t('personalForm.radioButtons.mamIco')
                  }}</label>

              </div>
              <div class="custom-control custom-radio">

                <input type="radio" class="custom-control-input" id="cinnostSecondary"
                       :class="{'is-invalid': isBlurred() && !choosedIco}"
                       value="nemam"
                       v-model="store.form.mamIco"
                       v-on:click="store.form.mamIco = 'nemam'; zmenaSidlaProducts()"/>
                <label class="custom-control-label" for="cinnostSecondary">{{
                    t('personalForm.radioButtons.nemamIco')
                  }}</label>

              </div>

              <!--     Další služby         -->
              <div v-if="store.form.mamIco === 'mam'" class="mt-4">
                <div class="jakeFormCustomLabel mb-2">
                  {{ t('personalForm.headers.dalsiSluzby') }}:
                </div>

                <div class="d-flex">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           id="vyrizeniZmenySidla"
                           class="custom-control-input"
                           v-model="store.form.vyrizeniZmenySidla"
                           ref="vyrizeniZmenySidla"
                           v-on:click="store.form.vyrizeniZmenySidla = !store.form.vyrizeniZmenySidla; zmenaSidlaProducts()"
                           value="">
                    <label for="vyrizeniZmenySidla"
                           class="custom-control-label">
                      <!--                                          {{ t('personalForm.radioButtons.mamZajem') }}-->
                      <!--                                          <tooltip title="zmenaSidla"></tooltip>-->
                    </label>

                  </div>
                  <p class="custom-control-label">
                    <span @click="$refs.vyrizeniZmenySidla.click">
                    {{ t('personalForm.radioButtons.mamZajem') }}
                    </span>
                    <tooltip title="zmenaSidla"></tooltip>
                  </p>
                </div>
              </div>

              <!--     Aktuální sídlo ve společenské smlouve         -->
              <div v-if="store.form.osoba === 'pravnicka'
              && store.form.vyrizeniZmenySidla
              && store.form.mamIco === 'mam'"
                   class="mt-4">
                <div class="jakeFormCustomLabel mb-2">
                  {{ t('personalForm.headers.sidloVeSmlouve') }}:
                  <tooltip title="sidloVeSmlouve"></tooltip>
                </div>
                <div v-if="isBlurred() && !choosedSidloVeSmlouve" class="small error-block text-danger mb-2">
                  {{ t('personalForm.required.selectOne') }}
                </div>

                <div class="custom-control custom-radio">
                  <input type="radio" class="custom-control-input" id="nevimPoradteMi"
                         value="nevim"
                         :class="{'is-invalid': isBlurred() && !choosedSidloVeSmlouve}"
                         v-model="store.form.sidloVeSmlouve"
                         v-on:click="store.form.sidloVeSmlouve = 'nevim'; zmenaSidlaProducts()"/>
                  <label class="custom-control-label" for="nevimPoradteMi">{{
                      t('personalForm.radioButtons.nevim')
                    }}</label>

                </div>
                <div class="custom-control custom-radio">
                  <input type="radio" class="custom-control-input" id="konkretniAdresa"
                         value="konkretniAdresa"
                         :class="{'is-invalid': isBlurred() && !choosedSidloVeSmlouve}"
                         v-model="store.form.sidloVeSmlouve"
                         v-on:click="store.form.sidloVeSmlouve = 'konkretniAdresa'; zmenaSidlaProducts()"/>
                  <label class="custom-control-label" for="konkretniAdresa">{{
                      t('personalForm.radioButtons.konkretniAdresa')
                    }}</label>
                </div>
                <div class="custom-control custom-radio">
                  <input type="radio" class="custom-control-input" id="obec"
                         value="obec"
                         :class="{'is-invalid': isBlurred() && !choosedSidloVeSmlouve}"
                         v-model="store.form.sidloVeSmlouve"
                         v-on:click="store.form.sidloVeSmlouve = 'obec'; zmenaSidlaProducts()"/>
                  <label class="custom-control-label" for="obec">{{
                      t('personalForm.radioButtons.obec')
                    }}</label>
                </div>
              </div>

              <!--     Nová adresa sídla radio butons         -->
              <div v-if="store.form.osoba === 'pravnicka'
              && store.form.vyrizeniZmenySidla
              && store.form.mamIco === 'mam'
              && store.form.sidloVeSmlouve === 'obec'"
                   class="mt-4">
                <div class="jakeFormCustomLabel mb-2">
                  {{ t('personalForm.headers.novaAdresaJe') }}:
                </div>
                <div v-if="isBlurred() && !choosedAdresaJe" class="small error-block text-danger mb-2">
                  {{ t('personalForm.required.selectOne') }}
                </div>

                <div class="custom-control custom-radio">
                  <input type="radio" class="custom-control-input" id="stejnaObec"
                         value="stejnaObec"
                         v-model="store.form.adresaSidlaJe"
                         :class="{'is-invalid': isBlurred() && !choosedAdresaJe}"
                         v-on:click="store.form.adresaSidlaJe = 'stejnaObec'; zmenaSidlaProducts()"/>
                  <label class="custom-control-label" for="stejnaObec">{{
                      t('personalForm.radioButtons.stejnaObec')
                    }}</label>

                </div>
                <div class="custom-control custom-radio">
                  <input type="radio" class="custom-control-input" id="jinaObec"
                         value="jinaObec"
                         v-model="store.form.adresaSidlaJe"
                         :class="{'is-invalid': isBlurred() && !choosedAdresaJe}"
                         v-on:click="store.form.adresaSidlaJe = 'jinaObec'; zmenaSidlaProducts()"/>
                  <label class="custom-control-label" for="jinaObec">{{
                      t('personalForm.radioButtons.jinaObec')
                    }}</label>
                </div>
              </div>


              <hr class="d-md-none">
            </div>


          </div>
        </div>
        <!-- Levy sloupec END-->


        <!-- Pravy sloupec-->
        <div class="col-12 col-md-6 d-flex flex-column justify-content-between">

          <div class=" mb-4" style="background-color: #f5f8fc">
            <div class="row p-3">
              <div class="col-1 pr-0 ml-auto">
                <!--                <i class="fa-solid fa-star"></i>-->
                <i class="fa-solid fa-clock-rotate-left"></i>
              </div>
              <div class="col-11 mr-auto" style="font-size: 0.8em;">
                <div v-html="t('step1InfoText')"></div>
              </div>
            </div>
          </div>

          <div class="mb-4">
            <div class="priceWrapper p-3" style="background-color: #f5f8fc">
              <div class="jakeFormCustomLabel mb-2 text-14" data-v-0f2e8fdc="">{{ t('souhrnCeny') }}:</div>
              <TotalPriceOfProducts/>
              <hr>
              <TotalPrice/>

            </div>


          </div>
        </div>


      </div>
    </div>


    <div class="pl-3 pl-md-3 pl-lg-1 pr-3 pr-md-4 ">

      <div class="row">
        <div class="col-12 d-none d-md-block col-md-5 text-center text-md-left pb-4 pb-md-0">
          <hr class="d-md-none mt-4">
          <NeedHelp/>
        </div>
        <div class="col-12 col-md-7 pl-0 pb-0 pb-md-4 text-right d-none d-md-block">

          <button class="btn btn-primary mr-md-3 px-4 " type="button" @click='nextStepDemand'>
            {{ t('buttons.poptat') }}
          </button>
          <button class="btn btn-secondary px-4" type="button" @click='nextStepOrder'>{{ t('buttons.objednat') }}
          </button>

        </div>
        <div class="col-12 col-md-7 pb-md-4 d-md-none">

          <div class="row">
            <div class="col-7 text-left">
              <button class="btn btn-sm btn-primary px-2" type="button" @click='nextStepDemand'>
                {{ t('buttons.poptat') }}
              </button>

            </div>
            <div class="col-5 text-right">
              <button class="btn btn-sm btn-secondary px-3" type="button" @click='nextStepOrder'>
                {{ t('buttons.objednat') }}
              </button>

            </div>
          </div>


        </div>

      </div>
    </div>
    <div class="text-center d-md-none pb-4">
      <div class="px-3">
        <hr>
      </div>
      <need-help/>
    </div>

  </div>
</template>

<script>
import {store} from "../store.js";
import {useI18n} from "vue-i18n";
import {ref} from 'vue'
import TotalPrice from "../others/TotalPrice.vue";
import NeedHelp from "../others/NeedHelp.vue";
import InputText from "../FormsInputs/inputText.vue";
import Tooltip from "../others/Tooltip.vue";
import TotalPriceOfProducts from "../others/TotalPriceOfProducts.vue";
import Steps from "../others/StepsComponent/Steps.vue";
import DebugMenu from "@/components/DebugMenu.vue";

export default {
  name: "StepOne",
  components: {Steps, TotalPriceOfProducts, Tooltip, NeedHelp, TotalPrice, InputText},

  props: ['currentStep'],
  setup() {
    const {t, locale} = useI18n({useScope: 'global'})
    const lang = locale;
    const select = ref(0)
    const hideSalePromoInfo = store.form.hideSalePromoInfo;
    const now = new Date();
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const salePromoEndDate = `${lastDay.getDate()}. ${lastDay.getMonth() + 1}. ${lastDay.getFullYear()}`;
    return {t, select, lang, hideSalePromoInfo, salePromoEndDate}
  },
  data() {
    return {
      errors: [],
      store,
      // selectSeat: store.getProduct(store.form.defaultSeatCode),
      selectSeat: null,
      selectSeatYear: null,
      orderSelecetdedSeatYear: null,

    }
  },
  methods: {
    finishStepEmit(name) {
      // console.log(`finishStepEmit ${name}`);
      this.nextStepOrder();
    },

    // celkova kontrola kroku
    isBlurred() {
      return this.store.form.steps.stepOne.blurred;
    },

    setSeatOwn() {
      // console.log('sup');
      this.store.order.seatChoose = 'own'
    },
    checkStep() {
      var order = this.store.order;
      this.store.form.steps.stepOne.filled = false;
      //if (!this.checkTradeType && order.type === 'order') return false;
      // if (!order.oborZivnosti) return false;
      if (!this.choosedIco) return false;
      if (!this.choosedOsobu) return false;
      if (this.store.form.mamIco === 'mam' && this.store.form.vyrizeniZmenySidla && this.store.form.osoba === 'pravnicka') {
        if (this.store.form.sidloVeSmlouve === '')
          return false;
        else if (this.store.form.sidloVeSmlouve === 'obec' && this.store.form.adresaSidlaJe === '')
          return false;
      }

      // if (this.store.order.type !== 'demand') {
      // if (!this.checkSeatType) return false;
      // if (this.choosedOwnSeat) {
      //   if (!order.ownSeatAddress.city) return false;
      //   if (!order.ownSeatAddress.street) return false;
      //   if (!order.ownSeatAddress.psc) return false;
      // }

      // }
      if (!this.selectSeat || !this.selectSeatYear) return false;


      return true;

    },
    nextStepOrder() {
      this.store.order.type = 'order';
      this.nextStep();
    },
    nextStepDemand() {
      this.store.order.type = 'demand';
      this.nextStep();
    },
    nextStep() {
      this.store.form.steps.stepOne.blurred = true;
      this.store.form.formEditing = true;
      // Zkontrolovat, zda URL již obsahuje '?form=editing' pro popup
      if (!window.location.href.includes('form=editing') && store.form.formEditing) {
        // Přidat nebo aktualizovat parametr 'form' v URL
        const newUrl = window.location.href.includes('?')
            ? window.location.href + '&form=editing'
            : window.location.href + '?form=editing';

        // Aktualizovat historii bez reloadu stránky
        window.history.pushState({form: 'edit'}, '', newUrl);
      }

      // if (this.store.order.seatChoose === 'virtual') {
      //   this.store.order.ownSeatAddress.city = ''
      //   this.store.order.ownSeatAddress.street = ''
      //   this.store.order.ownSeatAddress.psc = ''
      //
      // }
      // console.log('run check');
      var check = this.checkStep();
      if (check) {
        this.store.form.steps.stepOne.filled = true;
        this.store.form.steps.stepOne.visited = true;
        this.store.form.currentStep = 'stepTwo';

        if (this.store.order.type === 'order') { //začla objednávka
          this.store.seatClarityEvent('start-order');
          this.store.vueClarityEvent('start-order');
        } else if (this.store.order.type === 'demand') { // začla poptávka
          this.store.seatClarityEvent('start-demand');
          this.store.vueClarityEvent('start-demand');
        }

        this.store.gaEventNextStep('step2');
        this.store.scrollTop();
      } else {
        this.$nextTick(() => {
          this.store.scrollToErrorInput();
        })
        this.store.gaEventErrorForm('step2');
      }

    },
    nextStepTest() {
      // console.log('Step one, call fce na pokracovani');
    },


    // check zda se ve store nachazi zivnost a prida k ni poplatek za vyrizeni
    // kontrolaZivnosti() {
    //   var products = this.store.order.products.filter(obj => {
    //     return this.store.form.druhyZivnostiCodes.indexOf(obj.code) !== -1;
    //   });
    //   if (products.length > 0) {
    //     this.store.addProduct('ZU01');
    //   } else this.store.removeProduct('ZU01');
    // },
    // clearSelectSeatYear() {
    //   if (this.selectSeatYear) this.store.removeProduct(this.selectSeatYear.code);
    //   this.selectSeatYear = null;
    // },
    setSeat(seat) {
      this.selectSeat = seat;
      // this.selectSeatYear = this.selectSeat.formYears[0];
      this.selectSeatYear = seat.formYears[0];
    },
    setSeatYear(year) {
      this.selectSeatYear = year;
    },
    setDefaultSeat() {
      if(this.store.form.defaultSeatCode){
        this.setSeat(this.store.getProduct(this.store.form.defaultSeatCode));
        this.updateSeatInOrder()
      }
    },
    updateSeatInOrder() {
      // console.log("update seat in order");
      // this.store.order.seatChoose = 'virtual';
      if (!this.orderSelecetdedSeatYear) this.orderSelecetdedSeatYear = this.selectSeatYear;

      if (this.orderSelecetdedSeatYear !== this.selectSeatYear) {
        this.store.removeProduct(this.orderSelecetdedSeatYear.code);
        this.orderSelecetdedSeatYear = this.selectSeatYear;

      }
      if (this.selectSeatYear) this.store.addProduct(this.selectSeatYear.code);
      // console.log(this.store.order.products);
    },
    // removeSeatFromOrder() {
    //   if (this.orderSelecetdedSeatYear) {
    //     this.store.removeProduct(this.orderSelecetdedSeatYear.code)
    //     this.selectSeatYear = '';
    //     this.selectSeat = '';
    //   }
    // },

    preventPscInputFromLetter() {
      store.order.ownSeatAddress.psc = store.order.ownSeatAddress.psc.replace(/\D/g, '').substring(0, 5);
    },
    zmenaSidlaProducts() {
      // console.log('změna sídla');
      // console.log(this.store.form.vyrizeniZmenySidla);

      this.store.removeProduct('ZU12');
      this.store.removeProduct('ZU11');
      this.store.removeProduct('NZ01');
      this.store.removeProduct('NZ02');
      this.store.removeProduct('SOP_02');
      this.store.removeProduct('KO02');
      this.store.removeProduct('OR01');

      if (this.store.form.mamIco === 'mam' && this.store.form.vyrizeniZmenySidla) {
        if (this.store.form.osoba === 'fyzicka') {
          // přidání produktu vyřízení změny
          this.store.addProduct('ZU12');
          this.store.addProduct('ZU11');
        } else if (this.store.form.osoba === 'pravnicka') {
          if (this.store.form.sidloVeSmlouve === 'konkretniAdresa') {
            this.store.addProduct('NZ01');
            this.store.addProduct('NZ02');
            this.store.addProduct('SOP_02');
          } else if (this.store.form.sidloVeSmlouve === 'obec') {
            if (this.store.form.adresaSidlaJe === 'stejnaObec') {
              this.store.addProduct('KO02');
              this.store.addProduct('OR01');
            } else if (this.store.form.adresaSidlaJe === 'jinaObec') {
              this.store.addProduct('NZ01');
              this.store.addProduct('NZ02');
              this.store.addProduct('SOP_02');
            }
          }
        }
      }
      // console.log(this.store.order.products);
    },
    prepnoutAdresu(e) {
      // console.log("prepinam adresu");
      if (this.store.form.steps.stepOne.filled) {
        if (!store.form.formSucceed) {
          this.store.form.steps.stepOne.filled = false;
          this.store.form.steps.stepOne.blurred = false;
          this.store.form.steps.stepTwo.filled = false;
          this.store.form.steps.stepThree.filled = false;
          this.store.goToStep('stepOne');
        }
      }

      const seat = this.store.form.seatsProducts.filter(seat => {
        return seat.code === e.detail
      });
      // console.log(seat);
      // console.log(e.detail);
      if (seat.length === 1) {
        this.setSeat(seat[0]);
        this.updateSeatInOrder()
      }
    }
  },
  computed: {
    // kontrola jednotlivych poli

    // kontroluje, zda bylo zvoleno vlastni sidlo nebo virtualni
    // checkSeatType() {
    //   if (this.store.order.seatChoose) return true; else return false;
    // },
    // others
    getSelectedTradeTypes() {
      return this.store.order.products.filter(obj => {
        return obj.type === 'tradeType'
      });
    },
    // choosedVirtualSeat() {
    //   return this.store.order.seatChoose === 'virtual';
    // },
    // choosedOwnSeat() {
    //   return this.store.order.seatChoose === 'own';
    // },
    choosedOsobu() {
      return this.store.form.osoba !== '';
    },
    choosedIco() {
      return this.store.form.mamIco !== '';
    },
    choosedSidloVeSmlouve() {
      return this.store.form.sidloVeSmlouve !== '';
    },
    choosedAdresaJe() {
      return this.store.form.adresaSidlaJe !== '';
    }
    // isFilledOwnSeatAddress() {
    //   var address = this.store.order.ownSeatAddress;
    //   if (address.city.length < 1) return false;
    //   else if (address.street.length < 1) return false;
    //   else if (address.psc.length < 1) return false;
    //   else if (address.country.length < 1) return false;
    //   else return true;
    //
    // },
    // isFilledOwnSeatStreet() {
    //   return this.store.order.ownSeatAddress.street.length > 0;
    // },
    // isFilledOwnSeatCity() {
    //   return this.store.order.ownSeatAddress.city.length > 0;
    // },
    // isFilledOwnSeatPsc() {
    //   return String(this.store.order.ownSeatAddress.psc).length > 0;
    // },
    //
    // isDemand() {
    //   return this.store.order.type === 'demand';
    // },
  },
  mounted() {
    window.addEventListener('prepnout-adresu', this.prepnoutAdresu);
    this.setDefaultSeat();

    // this.selectSeat = this.store.getProduct(this.store.form.defaultSeatCode);
    // var seatCode = this.store.form.defaultSeatCode;
    // console.log(this.store.form.defaultSeatCode);
    // var seat = this.store.getProduct(seatCode);
    // this.selectSeat = seat;
    // this.selectSeatYear = seat;
    // this.updateSeatInOrder();
    // this.setDefaultSeat();
    // this.setDefaultSeat();
  },
  beforeDestroy() {
    window.removeEventListener('prepnout-adresu', this.prepnoutAdresu);

  },
  created() {
  }

}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/helper";

#oborZivnosti {
  &:focus {
    box-shadow: none;
    border-color: #ef4956;
  }
}

#formGroupOwnCountry {
  position: relative;

  .jake-form-tooltip {
    position: absolute;
    left: 115px;
    @media #{$xs} {
      right: 50px;
    }
    bottom: 12px;
  }

  #ownSeatAddressCountry {
    background-color: white;
    color: #dededf;
  }

}

/* Chrome, Safari, Edge, Opera */
#ownSeatPostCode::-webkit-outer-spin-button,
#ownSeatPostCode::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}

/* Firefox */
#ownSeatPostCode[type=number] {
  -moz-appearance: textfield !important;
}
</style>